(function () {
  'use strict';

  var sections = document.querySelectorAll('.brand-hero--has-video[data-pause-offscreen="true"]');
  if (!sections.length) return;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  sections.forEach(function (section) {
    var provider = section.getAttribute('data-video-provider');
    var native   = section.querySelector('video.brand-hero__video');
    var iframe   = section.querySelector('iframe.brand-hero__video-iframe');

    if (prefersReducedMotion) {
      if (native) {
        try { native.pause(); } catch (e) {}
      }
      if (iframe) {
        postIframeCommand(iframe, provider, 'pause');
      }
    }

    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          if (prefersReducedMotion) return;
          if (native && native.paused) {
            var p = native.play();
            if (p && typeof p.catch === 'function') p.catch(function () {});
          }
          if (iframe) {
            postIframeCommand(iframe, provider, 'play');
          }
        } else {
          if (native && !native.paused) {
            try { native.pause(); } catch (e) {}
          }
          if (iframe) {
            postIframeCommand(iframe, provider, 'pause');
          }
        }
      });
    }, { threshold: 0.1 });

    observer.observe(section);
  });

  function postIframeCommand(iframe, provider, command) {
    if (!iframe || !iframe.contentWindow) return;
    try {
      if (provider === 'youtube') {
        var func = command === 'play' ? 'playVideo' : 'pauseVideo';
        iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: func, args: [] }), '*');
      } else if (provider === 'vimeo') {
        var method = command === 'play' ? 'play' : 'pause';
        iframe.contentWindow.postMessage(JSON.stringify({ method: method }), '*');
      }
    } catch (e) {
      /* postMessage failures aren't actionable */
    }
  }
})();
